import React, { Component } from 'react'
import Select, { components } from 'react-select';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Snackbar from '@mui/material/Snackbar';
import { clearErrors } from '../../../ActionCreators/errorAction';
import { addQuery, resetQuery } from '../../../ActionCreators/AdminAction/managementorAction';
import { getSkills } from '../../../ActionCreators/learnAction';


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator-black.svg' alt='' />
        </components.DropdownIndicator>
    );
};

class AddQuery extends Component {
    state = {
        facultyError: '',
        openModal: false,
        category: '',
        search: '',
        questionError: '',
        question: '',
        skillId: '',
        successEnable: false,
        successMessageText: ''
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        this.props.getSkills(false);
    }


    addLink = () => {
        this.setState({
            isAddLink: true,
        })
    }

    handleModal = () => {
        this.setState({
            isAddLink: false
        })
    }

    getCatagory = (e) => {
        this.setState({
            category: e,
            catagoryId: e.value,
            categoryError: ''
        })
    }

    selectSkills = (e) => {
        this.setState({
            skill: e,
            skillId: e.value,
            skillError: ''
        })
    }



    changeQuestion = (val) => {
        this.setState({
            question: val,
            questionError: ''
        })
    }

    saveQuery = async () => {
        this.setState({
            isloading: true
        })
        if (this.state.skillId === '' || null) {
            this.setState({
                skillError: 'Please select Skill',
                isloading: false
            })
        }
        else if (this.state.category === '' || null) {
            this.setState({
                categoryError: 'Please select category',
                isloading: false
            })
        }

        else if (this.state.question.trim('') === '' || null) {
            this.setState({
                questionError: `Question can't  empty`,
                isloading: false
            })
        }
        else {
            let obj = {
                category: this.state.category.value,
                skill_id: this.state.skillId,
                attachments: [],
                question: this.state.question
            }
            await this.props.addQuery(obj)
            if (this.props.query) {
                await this.props.goBack();
                await this.props.resetQuery();
                this.setState({
                    isloading: false
                })
            }
        }
    }


    snackClosed = () => {
        this.props.clearErrors();
    }



    render() {
        const { catagories, theme, redirect, successEnable, successMessage, successMessageText, t } = this.props
        return (
            <div className='add-query-form'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />

                <div className='query-form'>
                    <div className='query-header'>
                        <img src='/images/back1.svg' onClick={() => redirect ? this.props.history.goBack() : this.props.goBack()} alt='' />
                        <p>{t('New Query')}</p>
                    </div>
                    <p className='mandatory'>All fields marked * are mandatory</p>
                    <div className='row'>

                        <div className='col-md-4'>
                            <div className='form-group mt-2'>
                                <label className='mb-2'>{t('Skills')}*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    options={this.props.skills?.map(el => [{ value: el._id, label: el.title, image: el.image }][0])}
                                    placeholder='Select Skill'
                                    value={this.state.skill}
                                    onChange={this.selectSkills}

                                />
                                <small>{this.state.skillError}</small>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group mt-2'>
                                <label className='mb-2'>{t('Question Category')}*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    options={catagories}
                                    placeholder='Select Question Category'
                                    value={this.state.category}
                                    onChange={this.getCatagory}
                                />
                                <small>{this.state.categoryError}</small>
                            </div>
                        </div>
                        <div className='col-md-4'>

                        </div>
                    </div>
                    <div className='form-group mt-3'>
                        <label className='mb-2'>{t('Enter Question')}*
                        </label>
                        <textarea
                            className='form-control'
                            rows='4'
                            cols='4'
                            // maxLength='300'
                            onChange={(e) => this.changeQuestion(e.target.value)}
                        />
                        <small>{this.state.questionError}</small>
                    </div>
                    {/* <div className='mt-4'>
                        <ul style={{ listStyle: 'none' }}>
                            <li className='position-relative mt-1 d-flex align-items-center' >
                                <img onClick={() => this.props.attachment && this.props.attachment.length >= 1 ? this.openSnackbar() : this.addLink()} src='/images/attachment.png' alt='' /> &nbsp;<p onClick={() => this.props.attachment && this.props.attachment.length >= 1 ? this.openSnackbar() : this.addLink()} style={{ color: '#F5821F', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}>Attach a file</p>(Optional)
                            </li>
                        </ul>
                        <ul className="resource-holder">
                            {
                                this.props.attachment !== undefined && this.props.attachment.map((el, index) => {
                                    var Extension = el
                                        .substring(el.lastIndexOf(".") + 1)
                                        .toLowerCase();
                                    return (
                                        <li className="resource border-bottom" >
                                            <div className="col-md-1 col-1 pl-0 resource-image" >
                                                <img src={Extension === 'pdf' ? '/images/file.png' : (Extension === 'png' || Extension === 'jpg' || Extension === 'jpeg') ? '/images/png-placeholder.png' : '/images/default.png'} alt='' />
                                            </div>
                                            <div className="col-md-9 col-9 recent-title">
                                                <div>
                                                    <p className='d-flex justify-content-start align-items-center mt-1 elipsis'>
                                                        {el}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-1 col-1 d-flex justify-content-end align-items-center cursor-pointer" style={{ marginLeft: window.innerWidth > 767 ? '' : 40 }} onClick={() => window.open(el, '_blank')}>
                                                <img src='/images/view_grey.svg' alt='' />
                                            </div>
                                        </li>
                                    )
                                })

                            }
                        </ul>
                    </div> */}
                    <button style={{ backgroundColor: theme.bgColor }} className='submit-btn mt-3' disabled={this.state.isloading ? true : false} onClick={this.saveQuery}>{t('Submit')}</button>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { catagories, query } = state.manageMentor
    const { skills } = state.learn
    const { theme } = state.account
    const { successMessageText, successMessage, successEnable } = state.error;

    return {
        catagories, skills, query, theme,
        successMessageText, successMessage, successEnable
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getSkills, addQuery, resetQuery, clearErrors
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddQuery))